import { computed, inject, unref } from 'vue-demi'
import { buildProp } from '@xzx-design/utils'
import { componentSizes } from '@xzx-design/constants'

import type { InjectionKey, Ref } from 'vue-demi'
import type { ComponentSize } from '@xzx-design/constants'

export const useSizeProp = buildProp({
  type: String,
  values: componentSizes,
  required: false,
} as const)

export const useSizeProps = {
  size: useSizeProp,
}

export interface SizeContext {
  size: Ref<ComponentSize>
}

export const SIZE_INJECTION_KEY: InjectionKey<SizeContext> = Symbol('size')

export const useGlobalSize = () => {
  const injectedSize = inject(SIZE_INJECTION_KEY, {} as SizeContext)

  return computed<ComponentSize>(() => {
    return unref(injectedSize.size) || ''
  })
}
